<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.has-text-centered
            h1.title {{ title }}
              | &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-4
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por serie | resguarda | ubicación | Oficina | Descripcion',
                  v-model="query_articulos",
                )
          .column.is-3(v-show="resultadoFilter !== ''")
            span.tag.is-warning
              | {{ resultadoFilter }}
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns(v-show="consumiblesShow.length > 0")
          .column(v-show="estacionSel === ''")
            Tb_Consumibles(:consumibles='consumiblesShow')
          .column(v-show="estacionSel !== ''")
            Tb_ConsumiblesSede(:consumibles='consumiblesShow')
</template>

<script>
  import Loader from '../../shared/Loader.vue'
  import NavBarInventario from '../layout/NavBarInventario.vue'
  import Tb_Consumibles from './components/Tb_Consumibles.vue'
  import Tb_ConsumiblesSede from './components/Tb_ConsumiblesSede.vue'
  import { mapState } from 'vuex'
  import InventarioServices from '../../../services/inventario/inventario'

  export default {
    name: "ConsumiblesCedes",
    components: { Loader, NavBarInventario, Tb_Consumibles, Tb_ConsumiblesSede },
    data() {
      return {
        isLoading: true,
        consumibles: [],
        consumiblesSelect: [],
        consumiblesShow: [],
        query: '',
        result_query: '',
        query_articulos: '',
        title: '',
        verOtros: false,
        almacenes: [],
        origen: {},
        resultadoFilter: '',
      }
    },
    watch: {
      query_articulos() {
        this.resultadoFilter = ''
        if (this.query_articulos === '') {
          this.consumiblesShow = this.consumiblesSelect
        } else {
          const QUERY_ARTICULOS = this.query_articulos.toUpperCase()
          const consumibles = this.consumiblesSelect.filter( cons => {
            return `${cons.modelo} ${cons.marca} ${cons.categoria} ${cons.subcategoria}`.toUpperCase().includes(QUERY_ARTICULOS)
          })
          this.consumiblesShow = consumibles
          this.resultadoFilter = `Coinicidencias: ${this.consumiblesShow.length} artículo${this.consumiblesShow.length == 1 ? '' : 's'}`
        }
      }
    },
    methods: {
      iniciarComponente () {
        this.obtenerAlmacenes()
      },
      
      obtenerConsumibles () {
        console.log(2)
        if (this.estacionSel !== '') {
          console.log(3)
          let almacenes = []
          if (this.estacionSel === 'DUCTO') {
            almacenes = this.almacenes.filter( a => a.ubicacion.includes('EB') || a.ubicacion.includes('ER'))
          } else {
            const ubi = this.estacionSel === 'CORP' ? 'CORPORATIVO' : this.estacionSel
            almacenes = this.almacenes.filter( a => a.ubicacion === ubi)
          }
          almacenes.forEach(alm => {
            InventarioServices.getConsumiblesAlmacen(alm.id_oficina)
              .then(res => {
                res.map( cons => {
                  const consConvert = this.convertirConsumiblesCede(cons, alm)
                  this.consumibles.push(consConvert)
                })
              })
              .catch( e => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
              })
          })
          this.consumiblesSelect = this.consumibles.sort()
          this.consumiblesShow = this.consumiblesSelect
          this.isLoading = false
        } else {
          console.log(4)
          InventarioServices.getConsumiblesAlmacen(this.origen.id_oficina)
            .then(res => {
              this.consumibles = res.map(this.convertirConsumibles)
              this.consumiblesSelect = this.consumibles
              this.consumiblesShow = this.consumiblesSelect
              this.isLoading = false
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
            })
        }
      },

      convertirConsumibles (cons) {
        return {
          ...cons,
            id: parseInt(cons.id),
            cantidad: parseInt(cons.cantidad),
            limite: parseInt(cons.limite),
        }
      },

      convertirConsumiblesCede (cons, alm) {
        const ofiUbi = `${alm.ubicacion} - ${alm.oficina}`
        return {
          ...cons,
            id: parseInt(cons.id),
            cantidad: parseInt(cons.cantidad),
            limite: parseInt(cons.limite),
            oficina: ofiUbi
        }
      },

      obtenerAlmacenes() {
        InventarioServices.getAlmacenesConsumibles('c')
          .then( data => {
            this.almacenes = data.map(this.convertirAlmacenes)
            this.obtenerAlmacenOrigen()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convertirAlmacenes (ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          id_ubicacion: parseInt(ofi.id_ubicacion),
          id_oficina: parseInt(ofi.id_oficina),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },

      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      obtenerAlmacenOrigen() {
        console.log(1)
        if (this.estacionSel !== '') {
          this.almacenes.map( alm => {
            const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
            if (encontrado) {
              this.origen = alm
            }
          })
        }
        this.obtenerConsumibles()
      },

      backPage () {
        this.$router.back()
      },
      
    },
    created () {
      if (this.estacionSel !== '') {
        const ubi = this.estacionSel === 'CORP' ? 'CORPORATIVO' : this.estacionSel
        this.title = `Consumibles ${ubi}`
      } else {
        const ubi = this.userLogin.ubicacion === 'CORP' ? 'CORPORATIVO' : this.userLogin.ubicacion
        this.title = `Consumibles ${ubi}`
      }
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'areaAsignacion', 'estacionSel'])
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/cedes/Consumibles.vue